import React, { useEffect, useState, useRef, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Video, Volume2, VolumeX } from 'lucide-react';
const videos = [{
  id: 1,
  url: 'https://cdn.magicpatterns.com/uploads/wAKM6NP2C5Rev82Kj1hmQo/Hidro1 demo.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 2,
  url: 'https://cdn.magicpatterns.com/uploads/w7tWRuTUz9zMKDbyZ1L5PH/Hidro2 demo.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 3,
  url: 'https://cdn.magicpatterns.com/uploads/nuQS2yMWHa6ijemBnmmq4h/Hidro3.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 4,
  url: 'https://cdn.magicpatterns.com/uploads/1T6pSojeJvJ6jR4U3CUAQR/Hidro4.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 5,
  url: 'https://cdn.magicpatterns.com/uploads/eLyf27rPt85VEL2SpYuapq/Hidro5.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 6,
  url: 'https://cdn.magicpatterns.com/uploads/fEKabPkkNFSuBPs8o555LL/icon 1 demo.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 7,
  url: 'https://cdn.magicpatterns.com/uploads/smTjYajS3Dj6943uQHTcDQ/icon 2 demo.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 8,
  url: 'https://cdn.magicpatterns.com/uploads/fEaLguCguXRE864j73fYbb/mia 1 demo.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 9,
  url: 'https://cdn.magicpatterns.com/uploads/akRprZe38QaAoqgZmgzHBH/mia 2 demo.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 10,
  url: 'https://cdn.magicpatterns.com/uploads/7UFaocdDjRWHDpUqBKuiz8/ashton 1 demo.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 11,
  url: 'https://cdn.magicpatterns.com/uploads/8gwx4Ub85gQwm2JWDKk5cY/ashton 2 demo.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 12,
  url: 'https://cdn.magicpatterns.com/uploads/tYeJPNL8weNT9UpEdeS3KV/ashton 3 demo.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 13,
  url: 'https://cdn.magicpatterns.com/uploads/acwjgQZcuV7Zj9bKoBKoSH/eloise 1 demo.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}, {
  id: 14,
  url: 'https://cdn.magicpatterns.com/uploads/1g5jud4ySxEBmMKNbzbDXT/conjunto 1 demo.mp4',
  title: 'Demo',
  format: 'Reel / TikTok'
}];
// Componente auxiliar para manejar el video y su audio correctamente
const CarouselVideo = ({
  src,
  isCenter
}: {
  src: string;
  isCenter: boolean;
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isMuted, setIsMuted] = useState(true);
  useEffect(() => {
    if (videoRef.current) {
      // Si no es el centro, siempre silenciado. Si es el centro, respeta el estado isMuted.
      videoRef.current.muted = !isCenter || isMuted;
      // Optimización: Solo reproducir el video si está en el centro
      if (isCenter) {
        // Usamos un catch por si el navegador bloquea el autoplay inicial
        videoRef.current.play().catch(e => console.log('Autoplay prevented:', e));
      } else {
        videoRef.current.pause();
      }
    }
  }, [isCenter, isMuted]);
  // Resetear el mute cuando el video deja de ser el centro
  useEffect(() => {
    if (!isCenter) {
      setIsMuted(true);
    }
  }, [isCenter]);
  const toggleMute = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsMuted(!isMuted);
  };
  return <div className="relative w-full h-full" data-id="element-64">
      <video ref={videoRef} src={src} className="w-full h-full object-cover" loop playsInline preload="metadata" muted={!isCenter || isMuted} data-id="element-65" />
      {isCenter && <button onClick={toggleMute} className="absolute top-4 right-4 z-50 p-2 rounded-full bg-black/50 border border-white/20 text-white hover:bg-[#00E5FF] hover:text-black transition-colors backdrop-blur-sm" data-id="element-66">
          {isMuted ? <VolumeX className="w-5 h-5" data-id="element-67" /> : <Volume2 className="w-5 h-5" data-id="element-68" />}
        </button>}
    </div>;
};
export function Showroom() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % videos.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + videos.length) % videos.length);
  const getPosition = (index: number) => {
    if (index === currentIndex) return 'center';
    if (index === (currentIndex - 1 + videos.length) % videos.length) return 'left';
    if (index === (currentIndex + 1) % videos.length) return 'right';
    return 'hidden';
  };
  const variants = {
    center: {
      x: '0%',
      scale: 1.15,
      zIndex: 20,
      opacity: 1
    },
    left: {
      x: '-90%',
      scale: 0.8,
      zIndex: 10,
      opacity: 0.4
    },
    right: {
      x: '90%',
      scale: 0.8,
      zIndex: 10,
      opacity: 0.4
    },
    hidden: {
      x: '0%',
      scale: 0.5,
      zIndex: 0,
      opacity: 0
    }
  };
  return <section className="py-24 bg-[#0a0a0a] border-y border-white/5 overflow-hidden" data-id="element-69">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <div className="text-center mb-16" data-id="element-71">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-72">
            Nuestra Fábrica en Acción
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-73">
            Explora nuestros formatos de alta conversión: UGC, Demos,
            Comparativos y Solución de Problemas.
          </p>
        </div>

        <div className="relative h-[550px] md:h-[650px] w-full max-w-5xl mx-auto flex items-center justify-center" data-id="element-74">
          {videos.map((video, index) => {
          const position = getPosition(index);
          const isCenter = position === 'center';
          return <motion.div key={video.id} initial={false} animate={position} variants={variants} transition={{
            duration: 0.5,
            ease: 'easeInOut'
          }} onClick={() => !isCenter && setCurrentIndex(index)} className={`absolute w-[260px] md:w-[320px] aspect-[9/16] bg-black rounded-3xl overflow-hidden border border-white/10 shadow-2xl ${isCenter ? 'glow-blue cursor-default' : 'cursor-pointer hover:opacity-60 transition-opacity'}`} data-id="element-75">
                {video.url ? <CarouselVideo src={video.url} isCenter={isCenter} data-id="element-76" /> : <div className="flex flex-col items-center justify-center text-gray-500 w-full h-full bg-gradient-to-b from-[#1a1a1a] to-black" data-id="element-77">
                    <Video className="w-16 h-16 mb-4 opacity-50" data-id="element-78" />
                    <p className="text-sm font-medium uppercase tracking-widest" data-id="element-79">
                      Espacio para Reel
                    </p>
                  </div>}

                {/* Overlay for styling */}
                <div className={`absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent pointer-events-none transition-opacity duration-500 ${isCenter ? 'opacity-100' : 'opacity-0'}`} data-id="element-80" />

                <div className={`absolute bottom-8 left-8 right-8 text-left pointer-events-none transition-opacity duration-500 ${isCenter ? 'opacity-100' : 'opacity-0'}`} data-id="element-81">
                  <span className="inline-block px-3 py-1 bg-[#00E5FF]/20 text-[#00E5FF] text-xs font-bold rounded-full mb-2 border border-[#00E5FF]/30" data-id="element-82">
                    {video.format}
                  </span>
                  <h3 className="text-xl md:text-2xl font-bold text-white drop-shadow-lg leading-tight" data-id="element-83">
                    {video.title}
                  </h3>
                </div>
              </motion.div>;
        })}

          {/* Controls */}
          <div className="absolute top-1/2 -translate-y-1/2 left-0 md:left-12 z-30" data-id="element-84">
            <button onClick={prev} className="p-3 rounded-full bg-black/50 border border-white/10 text-white hover:bg-[#00E5FF] hover:text-black transition-colors backdrop-blur-sm" data-id="element-85">
              <ChevronLeft className="w-6 h-6" data-id="element-86" />
            </button>
          </div>
          <div className="absolute top-1/2 -translate-y-1/2 right-0 md:right-12 z-30" data-id="element-87">
            <button onClick={next} className="p-3 rounded-full bg-black/50 border border-white/10 text-white hover:bg-[#00E5FF] hover:text-black transition-colors backdrop-blur-sm" data-id="element-88">
              <ChevronRight className="w-6 h-6" data-id="element-89" />
            </button>
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-12" data-id="element-90">
          {videos.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2 h-2 rounded-full transition-all ${idx === currentIndex ? 'w-8 bg-[#00E5FF]' : 'bg-white/20'}`} data-id="element-91" />)}
        </div>
      </div>
    </section>;
}